import { FC, PropsWithChildren } from "react";
import { cn } from "../utils";
type TFooterProps = PropsWithChildren & {
  className?: string;
};
const Footer: FC<TFooterProps> = props => {
  const {
    children,
    className
  } = props;
  return <footer className={cn("container fixed bottom-0 px-6 pt-4 pb-8", className)} data-sentry-component="Footer" data-sentry-source-file="Footer.tsx">
      {children}
    </footer>;
};
export default Footer;